import * as types from 'catalog/actions/types'

const initialState = {
  categoryList: [],
  subcategoryList: [],
  checkpointList: [],
  measureList: [],
  activeCategory: null,
  activeSubcategory: null,
  activeCheckpoint: null,
  categoryListLoading: false,
  checkpointListLoading: false,
  errors: {}
}

export default function categories(state = initialState, action) {
  const {
    type,
    payload
  } = action
  switch (type) {
    case types.FETCH_CATEGORY_LIST:
      return {
        ...state,
        categoryListLoading: true
      }
    case types.FETCH_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        categoryList: payload.categoryList,
        categoryListLoading: false
      }
    case types.CHOOSE_CATEGORY:
      return {
        ...state,
        activeCategory: payload.activeCategory,
      }
    case types.CHOOSE_SUBCATEGORY:
      return {
        ...state,
        activeSubcategory: payload.activeSubcategory,
      }
    case types.FETCH_SUBCATEGORIES:
      return {
        ...state,
        subcategoryList: payload.subcategoryList
      }
    case types.FETCH_CHECKPOINTS:
      return {
        ...state,
        checkpointListLoading: true
      }
    case types.FETCH_CHECKPOINTS_SUCCESS:
      return {
        ...state,
        checkpointList: payload.checkpointList,
        checkpointListLoading: false
      }
    case types.FETCH_CHECKPOINTS_ERROR:
      return {
        ...state,
        checkpointList: [],
        errors: action.payload,
        checkpointListLoading: false
      }
    case types.UNCHOOSE_CATEGORY:
      return {
        ...state,
        activeCategory: null,
        subcategoryList: [],
        activeSubcategory: null,
        checkpointList: []
      }
    case types.UNCHOOSE_SUBCATEGORY:
      return {
        ...state,
        activeSubcategory: null,
        checkpointList: []
      }
    case types.SEARCH_CATEGORY:
      return {
        ...state,
        categoryList: payload.categoryList,
        categoriesLoading: false
      }
    case types.UPDATE_CHECKPOINT:
      return {
        ...state,
        checkpointList: payload.checkpointList
      }
    case types.UPDATE_CATEGORY:
      return {
        ...state,
        categoryList: payload.categoryList,
        activeCategory: payload.activeCategory
      }
    case types.UPDATE_SUBCATEGORY:
      return {
        ...state,
        subcategoryList: payload.subcategoryList,
        activeSubcategory: payload.activeSubcategory
      }
    case types.ATTACHMENT_DELETED:
      return {
        ...state,
      }
    case types.DELETE_CHECKPOINT:
      return {
        ...state,
        checkpointList: payload.checkpointList
      }
    case types.SELECT_CHECKPOINT:
      return {
        ...state,
        activeCheckpoint: payload.activeCheckpoint,
      }
    case types.DESELECT_CHECKPOINT:
      return {
        ...state,
        activeCheckpoint: null,
        measureList: []
      }
    case types.FETCH_MEASURE_LIST:
      return {
        ...state,
        measureList: payload.measureList
      }
    case types.REORDER_CATEGORIES:
      return {
        ...state,
        categoryList: payload.categoryList
      }
    case types.REORDER_SUBCATEGORIES:
      return {
        ...state,
        subcategoryList: payload.subcategoryList
      }
    case types.REORDER_CHECKPOINTS:
      return {
        ...state,
        checkpointList: payload.checkpointList
      }
    case types.REORDER_MEASURES:
      return {
        ...state,
        measureList: payload.measureList
      }
    case types.DELETE_CATEGORY:
      return {
        ...state,
        activeCategory: null,
        activeSubcategory: null,
        categoryList: payload.categoryList
      }
    case types.DELETE_SUBCATEGORY:
      return {
        ...state,
        activeSubcategory: null,
        subcategoryList: payload.subcategoryList
      }
    case types.ADD_CHECKPOINT:
      return {
        ...state,
        checkpointList: payload.checkpointList,
        activeCheckpoint: null,
        measureList: []
      }
    case types.ADD_CATEGORY:
      return {
        ...state,
        categoryList: payload.categoryList,
        activeCategory: payload.activeCategory,
        activeSubcategory: null,
        subcategoryList: []
      }
    case types.ADD_SUBCATEGORY:
      return {
        ...state,
        subcategoryList: payload.subcategoryList,
        activeSubcategory: payload.activeSubcategory,
        activeCheckpoint: null,
        checkpointList: []
      }
    case types.ADD_MEASURE:
    case types.MEASURE_DELETED:
    case types.CHANGE_MEASURE:
      return {
        ...state,
        measureList: payload.measureList
      }
    case types.UPDATE_MEASURE_TAGS:
    default:
      return state
  }
}
